import { render, staticRenderFns } from "./SignatureAttachedFiles.vue?vue&type=template&id=a5041e32"
import script from "./SignatureAttachedFiles.vue?vue&type=script&lang=js"
export * from "./SignatureAttachedFiles.vue?vue&type=script&lang=js"
import style0 from "./SignatureAttachedFiles.vue?vue&type=style&index=0&id=a5041e32&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports